
import Confirmer from '@marketplace/components/forms/confirmer/confirmer.vue'

export default {
    name: 'ModalGeneralSuccess',

    components: {
        Confirmer,
    },

    props: {
        desc: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            isConfirmed: false,
            isbusyConfirming: false,
        }
    },

    mounted() {
        this.isbusyConfirming = true
        setTimeout(() => {
            this.isConfirmed = true
        }, 500)
    },
}
